import PropTypes from 'prop-types';
import { useAuth } from '../contexts/AuthContext';
import { hasRole } from '../utils/user';

function IsRole({ roles, children }) {
  const { profile } = useAuth();

  return hasRole(profile, roles) ? children : null;
}

IsRole.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

IsRole.defaultProps = {
  children: null,
};

export default IsRole;
